export const common = {
  active: '已啟用',
  inactive: '已停用',
  enabled: '已啟用',
  disabled: '已停用',
  search: '搜尋',
  filters: '篩選器',
  export: '匯出',
  import: '匯入',
  refresh: '重新整理',
  actions: '操作',
  loading: '載入中...',
  error: '錯誤',
  success: '成功',
  save: '儲存',
  cancel: '取消',
  delete: '刪除',
  edit: '編輯',
  create: '新建',
  view: '檢視',
  yes: '是',
  no: '否',
  confirm: '確認',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  close: '關閉',
  clear: '清除',
  today: '今天',
  yesterday: '昨天',
  lastWeek: '過去 7 天',
  lastMonth: '過去 30 天',
  customRange: '自訂範圍',
};

export const accessDenied = {
  title: '無存取權限',
  description: '您沒有權限訪問此頁面。如果您認為這是錯誤，請聯絡系統管理員。',
  requiredPermission: '所需權限',
  goBack: '返回',
  goHome: '返回首頁',
};

export const validation = {
  required: '此欄位為必填',
  maxLength: '最多 %{count} 個字元',
  minLength: '至少 %{count} 個字元',
  maxValue: '最多 %{max}',
  minValue: '最少 %{min}',
  mustBePositive: '必須大於 0',
  nameInvalidChars: '只允許字母、數字、空格、連字符和底線',
  invalidOption: '無效的選項',
  invalidUrl: '無效的網址',
  invalidUuid: '無效的識別碼格式',
  invalidEmail: '無效的電郵地址',
  invalidType: '數值類型不正確',
  formHasErrors: '部分欄位需要修正',
  // Backend business rules
  nameAlreadyExistsInSite: '此站點已有相同名稱',
  priorityAlreadyExistsInSite: '此站點已有相同優先級',
  templateNameAlreadyExists: '範本名稱已存在',
  manualCodeAlreadyInUse: '手動輸入碼已被使用',
  manualCodeFormat: '手動輸入碼必須是 4 個字元，僅限：23456789ACDEFGHJKMNPQRTUVWXY',
  singlePhaseVoltageCap: '單相電壓不能超過 480V',
  maxPowerBelowCapacity: '最大功率不能低於 %{min} kW（充電樁總容量）',
  siteNotFound: '找不到站點',
  loadGroupNotFound: '找不到負載群組',
  loadGroupDifferentSite: '負載群組屬於其他站點',
  chargerTypeIdAlreadyExists: '充電樁類型 ID 已存在',
  chargerTypeNameAlreadyExists: '充電樁類型名稱已存在',
  firmwareVersionAlreadyExists: '此廠商／型號的韌體版本已存在',
  fileRequired: '請選擇檔案',
  vendorRequired: '請選擇廠商',
  modelRequired: '請選擇型號',
  versionRequired: '請輸入版本',
  mustNotBeEmpty: '不能為空',
  vendorCodeAlreadyExists: '供應商代碼已存在',
  bulkVendorRequired: '批次更新需要指定廠商',
  bulkModelRequired: '批次更新需要指定型號',
  targetTypeInvalid: '目標類型必須是：charger、site 或 bulk',
  firmwareNotFound: '找不到韌體',
  firmwareInactive: '無法使用已停用的韌體進行更新',
  vendorNotFound: '找不到供應商',
  phoneNumberAlreadyExists: '電話號碼已存在',
  appUserNotFound: '找不到應用程式用戶',
  rfidUserNotFound: '找不到 RFID 用戶',
  cardLinkExclusive: '卡片只能連結到應用程式用戶或 RFID 用戶其中之一，不能同時連結',
  usernameInUse: '此用戶名稱已被使用',
  emailInUse: '此電郵地址已被使用',
  roleNameAlreadyExists: '角色名稱已存在',
  supabaseConnectionNameAlreadyExists: '此名稱的 Supabase 連線已存在',
  feeTemplateNameAlreadyExists: '收費範本名稱已存在',
  feeTemplateNotFound: '找不到收費範本',
  feeTemplateInactive: '無法使用已停用的收費範本',
  entityNotFound: '找不到 %{type}',
  scheduleOverlap: '此實體已有重疊的收費排程',
  feeStructureRequired: '未使用範本時必須提供收費結構',
  currencyRequired: '未使用範本時必須提供貨幣',
  promotionCodeAlreadyExists: '此優惠碼已存在',
  sharedCodeRequired: '共享優惠類型必須提供優惠碼',
  codeTypeNoneNoCode: '優惠類型為「無」時不應設定優惠碼',
  validUntilAfterValidFrom: '結束日期必須晚於開始日期',
  titleRequired: '請輸入標題',
  displayTypeInvalid: '顯示類型必須是圖片或漸層',
  imageUrlRequired: '圖片橫幅必須提供圖片網址',
  gradientStartColorRequired: '漸層橫幅必須提供起始顏色',
  gradientEndColorRequired: '漸層橫幅必須提供結束顏色',
  groupNameAlreadyExists: '此群組名稱已存在',
  timezoneInvalid: '提供的時區無效',
  settingKeyAlreadyExists: '此設定鍵已存在',
  currentPasswordIncorrect: '目前密碼不正確',
  verificationCodeInvalid: '驗證碼無效或已過期',
  passwordIncorrect: '密碼不正確',
  passwordRequired: '請輸入密碼',
};